import type { FC, ReactElement } from 'react'
import React from 'react'

import { useLocalTheme } from '@vfuk/core-themes'
import Paragraph from '@vfuk/core-paragraph'
import type { IconProps } from '@vfuk/core-icon'
import Icon from '@vfuk/core-icon'
import InlineLink from '@vfuk/core-inline-link'
import { getDataSelector } from '@vfuk/core-base-props'

import * as Styled from './styles/InLineNotification.style'
import type { InLineNotificationProps } from './InLineNotification.types'

import defaultTheme from './themes/InLineNotification.theme'

const InLineNotification: FC<InLineNotificationProps> = ({
  appearance = 'primary',
  state,
  link,
  text,
  srAnnounce,
  localTheme,
  id,
  dataSelectorPrefix,
  dataAttributes,
}: InLineNotificationProps): ReactElement => {
  const componentName = 'InLineNotification'
  const inlineNotificationTheme = useLocalTheme(componentName, defaultTheme, localTheme)

  const { inverseText, inverseIcon } = inlineNotificationTheme.appearance[appearance]

  const iconName: IconProps['name'] = `${state}${inverseIcon ? '-inverse' : ''}`

  return (
    <Styled.InLineNotification
      appearance={appearance}
      inlineNotificationTheme={inlineNotificationTheme}
      role={srAnnounce ? 'alert' : ''}
      id={id}
      data-selector={getDataSelector(dataSelectorPrefix)}
      data-component-name={componentName}
      {...dataAttributes}
    >
      <Styled.IconWrapper>
        <Icon
          name={iconName}
          group='state'
          size={2}
          isResponsive={false}
          dataSelectorPrefix={getDataSelector(dataSelectorPrefix, 'icon')}
        />
      </Styled.IconWrapper>
      <Paragraph noMargin={true} inverse={inverseText} dataSelectorPrefix={getDataSelector(dataSelectorPrefix, 'text')}>
        {link ? (
          <>
            {`${text} `}
            <InlineLink
              onClick={link!.onClick}
              onMouseDown={link!.onMouseDown}
              onMouseUp={link!.onMouseUp}
              onTouchStart={link!.onTouchStart}
              onTouchEnd={link!.onTouchEnd}
              customRouterProps={link!.customRouterProps}
              href={link!.href}
              htmlAttributes={link!.htmlAttributes}
              dataAttributes={link!.dataAttributes}
              dataSelectorPrefix={getDataSelector(dataSelectorPrefix, 'link')}
              inverse={inverseText}
            >
              {link!.text}
            </InlineLink>
          </>
        ) : (
          text
        )}
      </Paragraph>
    </Styled.InLineNotification>
  )
}

export default InLineNotification
